import {
  Checkbox,
  CrudMode,
  DataDisplay,
  formatBoolean,
  Grid,
  pn,
  Stack,
  useElementBreakpoints,
  ValidationErrors,
} from "@compass/core";
import { Input } from "components";
import { Grade, GradeViewResource } from "generated/openApi";
import produce from "immer";
import "moment-timezone";

export const GradePageBody = (props: {
  crudMode: CrudMode;
  grade: Grade;
  setGrade: (value: Grade) => void;
  viewResource: GradeViewResource;
  validationErrors: ValidationErrors;
}) => {
  const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
  const properties = props.viewResource.properties || [];

  const nameField = () => {
    const propertyName = pn<Grade>("name");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.grade.name}</DataDisplay>
    ) : (
      <Input
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.grade.name}
        onChange={(e) =>
          props.setGrade(
            produce(props.grade, (draft) => {
              draft.name = e.target.value;
            })
          )
        }
      />
    );
  };

  const passingField = () => {
    const propertyName = pn<Grade>("passing");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{formatBoolean(props.grade.passing)}</DataDisplay>
    ) : (
      <Stack justifyContent="center" height="100%">
        <Checkbox
          label={property?.displayName}
          checked={props.grade.passing}
          onChange={(e) =>
            props.setGrade(
              produce(props.grade, (draft) => {
                draft.passing = e.target.checked;
              })
            )
          }
        />
      </Stack>
    );
  };

  const atRiskField = () => {
    const propertyName = pn<Grade>("atRisk");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{formatBoolean(props.grade.atRisk)}</DataDisplay>
    ) : (
      <Stack justifyContent="center" height="100%">
        <Checkbox
          label={property?.displayName}
          checked={props.grade.atRisk}
          onChange={(e) =>
            props.setGrade(
              produce(props.grade, (draft) => {
                draft.atRisk = e.target.checked;
              })
            )
          }
        />
      </Stack>
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={smallFieldBreakpoints}>
        {nameField()}
      </Grid>

      <Grid item xs={smallFieldBreakpoints}>
        {passingField()}
      </Grid>

      <Grid item xs={smallFieldBreakpoints}>
        {atRiskField()}
      </Grid>
    </Grid>
  );
};
